import { Injectable, } from '@angular/core';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { CurrencyExchange } from '../models/database-models/CurrencyExchange.model';
import { Store } from '@ngrx/store';
import { addCurrencyExchange } from 'src/app/core/store/CurrencyExchange.action';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  currencyExchangeRates: CurrencyExchange[] = [];

  constructor(private backEndService: BackendApiService, private store: Store<{ currency: CurrencyExchange[] }>) {
    // initialized with USD
    // better create or have an api to get the list of currency exchange
    this.getCurrency("USD");

    this.store
      .select('currency')
      .subscribe((currencies: CurrencyExchange[]) => this.currencyExchangeRates = currencies);
  }

  public getCurrency(currCode: string): CurrencyExchange | null {
    if(this.currencyExchangeRates.some((item) => item.FromCurrency === currCode)) {
      return this.currencyExchangeRates.find(item => item.FromCurrency === currCode)!;
    }
    let exchange: CurrencyExchange | null = null;

    this.backEndService.getCurrencyExchange(currCode).subscribe((response: CurrencyExchange) => {
      this.store.dispatch(addCurrencyExchange({ currency: response }));
      exchange = response;
    })

    return exchange;
  }

  public convertCurrencyToSGD(
    amount: number
    , currCode: string
    , exchangeRateCurrency?: number
  ): number | null {

    if (!currCode || currCode == 'SGD') return amount;
    
    let currency = this.getCurrency(currCode);
    if(!currency) return null;
    
    let exchangeRate: number = currency.Rate;
    if (exchangeRateCurrency) {
      exchangeRate = exchangeRateCurrency;
    }

    let result = amount * (exchangeRate / currency.RatioForTheFromCurrencyUnits);
    
    return result;
  }

  public async getAsyncCurrency(currCode: string): Promise<CurrencyExchange | null> {
    if(this.currencyExchangeRates.some((item) => item.FromCurrency === currCode)) {
      return this.currencyExchangeRates.find(item => item.FromCurrency === currCode)!;
    }
    let exchange: CurrencyExchange | null = await lastValueFrom(this.backEndService.getCurrencyExchange(currCode))
    this.store.dispatch(addCurrencyExchange({ currency: exchange }));
    return exchange;
  }

  public async convertAsyncCurrencyToSGD(
    amount: number
    , currCode: string
    , exchangeRateCurrency?: number
  ): Promise<number | null> {

    if (!currCode || currCode == 'SGD') return amount;
    
    let currency = await this.getAsyncCurrency(currCode);
    if(!currency) return null;
    
    let exchangeRate: number = currency.Rate;
    if (exchangeRateCurrency) {
      exchangeRate = exchangeRateCurrency;
    }

    let result = amount * (exchangeRate / currency.RatioForTheFromCurrencyUnits);
    
    return result;
  }

}
